export default __webpack_public_path__ + "static/media/thailand_covidsation.32eacc1f.jpg";